"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
var _SNETLogo = _interopRequireWildcard(require("../SNETLogo"));
var _styles = require("./styles");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const SnetFooterColumn = _ref => {
  let {
    column
  } = _ref;
  const classes = (0, _styles.useStyles)();
  const columnClassName = column.isPrimary ? `${classes.footerColumn}, ${classes.primary}` : classes.footerColumn;
  const ColumnTitle = () => {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, column.isPrimary ? /*#__PURE__*/_react.default.createElement(_SNETLogo.default, {
      variant: _SNETLogo.logoVariants.LIGHT,
      additionalClassName: classes.columnTitle
    }) : /*#__PURE__*/_react.default.createElement("h3", {
      className: classes.columnTitle
    }, column.title));
  };
  const ColumnLinks = () => {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("ul", {
      className: classes.columnLinks
    }, column.links.map(link => /*#__PURE__*/_react.default.createElement("li", {
      key: link.key
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: link.href,
      className: classes.columnLink,
      target: "_blank",
      rel: "noreferrer"
    }, link.label)))));
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: columnClassName
  }, /*#__PURE__*/_react.default.createElement(ColumnTitle, null), /*#__PURE__*/_react.default.createElement(ColumnLinks, null)));
};
var _default = exports.default = SnetFooterColumn;